module.exports = __webpack_public_path__ + "img/fuwushiyong.36b9bc55.png";